import { IOption } from '@cian/ui-kit';
import { locationsInOrder } from '../../settings';

export function getLocationsInOrder(locationsOptions: IOption[]): IOption[] {
  return locationsInOrder.reduce((acc, curr) => {
    const location = locationsOptions.find(item => item.value === curr);

    if (!location) {
      return acc;
    }

    return [...acc, { value: location.value, label: location.label }];
  }, []);
}
